export const TICKET_VIEW_QA = 'ticketView';
